<svg [attr.width]="iconSizeInPx" [attr.height]="iconSizeInPx">
  <image [attr.href]="iconSrc" [attr.width]="iconSizeInPx" [attr.height]="iconSizeInPx"></image>
</svg>
